import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {persistor, store } from './Store/store';
import { PersistGate } from 'redux-persist/integration/react';
import { Provider } from 'react-redux';
import { createTheme } from '@mui/material';
import { ThemeProvider } from '@mui/material';
import { HelmetProvider } from "react-helmet-async";

const rootElement = document.getElementById('root');
const theme = createTheme({
  palette: {
    secondary: {
      main: '#540326',
    },
  },
});

const appElement = (
  <ThemeProvider theme={theme}>
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
  <React.StrictMode>
    <HelmetProvider>
    <App />
    </HelmetProvider>
  </React.StrictMode>
  </PersistGate>
  </Provider>
  </ThemeProvider>
);

// When using react-snap for SEO pre-rendering, hydrateRoot can cause double-renders
// and visual flashes due to state mismatch (e.g., dynamic counters, animations).
// Clearing innerHTML before creating the root guarantees clean, seamless mounting.
if (rootElement.hasChildNodes()) {
  rootElement.innerHTML = '';
}
const root = ReactDOM.createRoot(rootElement);
root.render(appElement);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(//console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
